import React, {Component} from 'react'
import Report from '../../Report/Report'
import './RoadModule.sass'

class RoadModule extends Component {
  componentDidMount() {

  }

  render() {
    const input2 = JSON.parse(localStorage.getItem('InputParams2')) || false

    let valueRoughness = 'Введите параметр обработки'
    let valueQuality = 'Введите параметр обработки'

    if (input2.roughness) {
      valueRoughness = input2.roughness
    }

    if (input2.quality) {
      valueQuality = input2.quality
    }

    return (
      <React.Fragment>
        <main className='params'>

          <h1 className='params__title'>Маршрут обработки и припуски на обработку</h1>

          <div className="params-content">
            <div className="secondInput">
              <div className="params-content-descr">
                <div className="params-label second-input road-input">
                  <h2 className="params-label__item road-input__item bolder">Последовательность обработки</h2>
                  <h2 className="params-label__item bolder">Припуск</h2>

                </div>

                <div className="params-label second-input road-input">
                  <span className="params-label__item road-input__item ">Предварительно шлифование</span>
                  <span className="params-label__value road-input__value">0,12</span>

                </div>

                {+valueQuality === 8
                  ? null
                  : <div className="params-label second-input road-input">
                      <span className="params-label__item road-input__item ">Окончательное шлифование</span>
                      <span className="params-label__value road-input__value">0,08</span>
                    </div>}

              </div>
            </div>
          </div>
          <div className="params-content">
            <div className="secondInput">
              <div className="params-content-descr">

                <div className="params-label second-input road-input">
                  <span className="params-label__item road-input__item ">Точность обработки</span>
                  <span className="params-label__value road-input__value">{valueQuality} квалитет</span>

                </div>

                <div className="params-label second-input road-input">
                  <span className="params-label__item road-input__item ">Шероховатость после обработки</span>
                  <span className="params-label__value road-input__value">{valueRoughness}</span>

                </div>

              </div>
            </div>
          </div>

        </main>
        <Report/>
      </React.Fragment>
  )
  }
  }

  export default RoadModule